import axios from "axios";

class WorkflowMessagesService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Lucia Alvarado
   * @description Get a workflowExecution existing by id from A3Cloud
   * @date 15-02-2023
   * @param {String} token
   * @param {uuid} workflowExecutionId
   * @returns {Object}
   * @memberof WorkflowMessagesService
   */
  async getWorkFlowExecutionMessage(workflowExecutionId, timezone, token) {
    let response = await axios.get(
      `${this.apiUrl}/workflow-execution-messages?workflowExecutionId=${workflowExecutionId}&timezone=${encodeURIComponent(timezone)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Save notification messages on DB govo-api
   * @date 15-02-2023
   * @param {String} token
   * @param {uuid} workflowExecutionId
   * @param {number} workflowExecutionMemberId
   * @returns {Object}
   * @memberof WorkflowMessagesService
   */
  async createWorkflowExecutionNewMessage(messageConversation, token) {
    let response = await axios.post(
      `${this.apiUrl}/workflow-execution-new-message`,
      messageConversation,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }

  /**
   * @author Adriana Fernandez
   * @description Get all user's chats/discussions
   * @date 06-09-2023
   * @param {String} token
   * @param {uuid} workflowExecutionId
   * @returns {Object}
   * @memberof WorkflowMessagesService
   */
  async getChats(timezone, token) {
    let response = await axios.get(
      `${this.apiUrl}/discussions?timezone=${encodeURIComponent(timezone)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Get a workflowExecution existing by id from A3Cloud
   * @date 15-02-2023
   * @param {uuid} workflowExecutionId
   * @param {string} timezone 
   * @param {string} email 
   * @returns {Object}
   * @memberof WorkflowMessagesService
   */
  async getWorkFlowExecutionMessagePublic(workflowExecutionId, timezone, email) {
    let response = await axios.get(`${this.apiUrl}/workflow-execution-messages-public?email=${email}&workflowExecutionId=${workflowExecutionId}&timezone=${encodeURIComponent(timezone)}`);
    return response.data;
  }
}

export { WorkflowMessagesService as default };
